import { load1Mind } from "./1mind.js";
import { addConsentCallback } from "./lib/onetrust-helpers.js";
import { loadScript } from "./lib/load-script.js";
import { attach1MindEventListener } from "./segment/1mind.js";

addConsentCallback("C0001", () => {
  // Load the 1Mind Widget script
  // load1Mind({ widget: true, waveform: true });

  loadScript("https://launcher.1mind.com/deployment-57rvbvp22w", {});
  attach1MindEventListener();
});
